// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useLoggedInUser } from '../../../contexts/UserProvider';
import { removeUsersFromBlacklist } from '../../../utils/operationalApi';

const useRemoveBlacklistedUsers = () => {
  const { userAccessToken } = useLoggedInUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['removeBlacklistedUsers'],
    mutationFn: (partyIds: string[]) => removeUsersFromBlacklist(userAccessToken, partyIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['blacklistedUsers'] });
    },
  });
};

export default useRemoveBlacklistedUsers;
